import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { noop } from 'lodash';
import { cleanDescription } from '../../utils';

class ProviderCard extends Component {
  constructor(props) {
    super(props);

    this.onCardClick = this.onCardClick.bind(this);
    this.onCardMouseEnter = this.onCardMouseEnter.bind(this);
    this.onCardMouseLeave = this.onCardMouseLeave.bind(this);
  }

  onCardClick() {
    const { onCardClick, provider } = this.props;
    onCardClick(provider);
  }

  onCardMouseEnter() {
    const { onCardMouseEnter, provider } = this.props;
    onCardMouseEnter(provider);
  }

  onCardMouseLeave() {
    const { onCardMouseLeave, provider } = this.props;
    onCardMouseLeave(provider);
  }

  render() {
    const {
      provider,
      selectedProvider,
    } = this.props;

    const cardClass = `uu-provider-card ${provider === selectedProvider ? 'uu-provider-card--active' : ''}`;

    return (
      <div
        className={cardClass}
      >
        <button
          className="uu-provider-card__button"
          onBlur={this.onCardMouseLeave}
          onClick={this.onCardClick}
          onFocus={this.onCardMouseEnter}
          onKeyPress={noop}
          onMouseEnter={this.onCardMouseEnter}
          onMouseLeave={this.onCardMouseLeave}
          tabIndex={0}
          type="button"
        >
          {
            provider.logo_url && (
              <div className="uu-provider-card__image">
                <img
                  alt={provider.name}
                  src={provider.logo_url}
                />
              </div>
            )
          }
          <h5>{provider.name}</h5>
          <div className="uu-provider-card__description">
            {cleanDescription(provider.description)}
          </div>
        </button>
      </div>
    );
  }
}

ProviderCard.propTypes = {
  onCardClick: PropTypes.func.isRequired,
  onCardMouseEnter: PropTypes.func.isRequired,
  onCardMouseLeave: PropTypes.func.isRequired,
  provider: PropTypes.object.isRequired,
  selectedProvider: PropTypes.object.isRequired,
};

export default ProviderCard;



// WEBPACK FOOTER //
// ./public/js/components/ProviderList/ProviderCard.jsx